<template>

    <!-- Modal Trigger Button -->

    <div>

        <div class="row">

            <div class="col-12">

                <div class="page_action">

                    <div class="tw-w-full text-right">

                        <button
                            type="button"
                            class="btn btn-sm btn-danger"
                            @click="confirmDelete(menu.id)"
                        >

                            <i class="fa fa-trash"></i>
                             ลบ
                        </button>

                    </div>

                </div>

            </div>

        </div>

        
    </div>

</template>

<script>
 export default { props: ["shop", "salepageId", "menu"], data() { return { loading:
false, } }, methods: {
    confirmDelete(id) {
            this.$swal({
                icon: "warning",
                title: "ต้องการลบเมนูนี้ใช่ไหม?",
                text: "เมื่อกดยืนยัน เมนูนี้จะถูกลบ",
                confirmButtonText: "ยืนยัน",
                showCancelButton: true,
                cancelButtonText: "ยกเลิก",
                reverseButtons: true
            }).then(result => {
                if (result.isConfirmed) {
                    this.delete(id);
                }
            });
        },

        async delete(id) {
            this.loading = true;
            await axios
                .delete(`/backend/s/${this.shop}/salepages/${this.salepageId}/menu/${id}`)
                .then(res => {
                    this.$emit("onUpdate");
                    this.loading = false;
                })
                .catch(err => {});
        }


 } }
</script>

